import React from 'react'

const Manual_inventario_tipos_mermas = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
    <div className="mt-16">
      <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
        Inventario - Tipos de Mermas
      </h2>
      <p className="text-lg text-gray-700 mb-6">
        Este guía es fundamental para optimizar la gestión de inventarios al enseñarte a crear y clasificar tipos de mermas en tu sistema. Comprender las razones detrás de las mermas y documentarlas mejora la eficiencia operativa y reduce pérdidas.
      </p>
      <iframe
        src="https://scribehow.com/embed/Inventario__Tipos_de_Mermas__HblARPirT42UpbjHX1E7dg?as=scrollable"
        className="scribe-iframe-general-38"
        width="100%"
        height="3400"
        allowFullScreen
        style={{ border: 0, minHeight: '640px' }}
      ></iframe>
    </div>
  </div>
  )
}

export default Manual_inventario_tipos_mermas